<template>
  <div class="d-flex">
    <div style="width:276px;">
      <camera-live-view v-if="isCameraActive" width="276" height="207" :printer-id="printerId" :webcam-id="printer.webcam_id"></camera-live-view>
      <b-img v-else width="276" height="207" :src="getNoCameraImage()"></b-img>
    </div>
    <b-form-textarea ref="textarea" class="ml-2" rows="15" style="width: 100%;" readonly :value="logs"></b-form-textarea>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import CameraLiveView from "../camera/CameraLiveView";
  import CameraMixin from "../../../mixins/camera";
  import PrinterMixin from "../../../mixins/printer";

  export default {
    name: 'printer-log',
    components: {CameraLiveView},
    mixins: [PrinterMixin, CameraMixin],
    props: {
      printerId: {
        type: [Number, String],
        required: true
      }
    },
    data() {
      return {
        loaded: false,
        processing: false,
        logs: '',
        duration: null,
        intervalPromise: null
      }
    },
    created() {
      this.loadLogs();
      this.intervalPromise = setInterval(this.loadLogs, 2000);
    },
    beforeDestroy() {
      if (this.intervalPromise) {
        clearInterval(this.intervalPromise);
      }
    },
    computed: {
      ...mapGetters(['getPrinterIndex', 'getPrinters']),

      printer() {
        const printerIndex = this.getPrinterIndex(this.printerId);
        if (printerIndex >= 0) {
          return this.getPrinters[printerIndex];
        }

        return  undefined;
      },

      isCameraActive() {
        return this.printer.camera_type !== 'Disable camera';
      }
    },
    methods: {
      ...mapActions(['fetchPrinterLogs']),

      loadLogs() {
        this.fetchPrinterLogs({printerId: this.printerId, duration: this.duration}).then(({data}) => {
          this.loaded = true;
          if (data.result) {
            if (data.message.length) {
              for(let i in data.message) {
                this.logs += `[${data.message[i].dt}] ${data.message[i].message} \t\r`;
              }
              this.duration = data.message[data.message.length - 1].dt;
              const textarea = this.$refs.textarea.$el;
              textarea.scrollTop = textarea.scrollHeight;
            }
          }
        }).catch(e => {
          console.log(e);
        })
      }
    }
  }
</script>
